import React from "react";
import { Workflow, useBCMSContext, BCMSRecord } from "bcms-react";
import Classes from "model";
import StatementSearchItem from "./classes/StatementSearchItem";

import StatementsPage from "components/pages/StatementsPage";

const steps = [ StatementsPage ];

/**
 * @function StatementSearchWorkflow
 * @returns {React.Component}
 * @description The main workflow component for the statements search widget
 * @exported true
 * @example
 * <StatementSearchWorkflow />
 */
export default function StatementSearchWorkflow(props) {
    const controller = useBCMSContext();
    const value = getDefaultSearch(controller);

    return <Workflow value={ value } steps={ steps } />
}
/**
 * @function getWorkflowSteps
 * @returns {ARRAY}
 * @description Hook to return the steps of the workflow
 * @exported true
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefaultSearch
 * @returns {OBJECT}
 * @description Return am object with all the info required for the workflow
 * @exported true
 */
export const getDefaultSearch = controller => {
    BCMSRecord.globalControllerFor(Classes, controller);

    return {
        data: {
            search: StatementSearchItem.init({})
        },
        ui: {}
    }
};